// 手机号打码
exports.mobile = (val) => {
  if (val) {
    return val.substr(0, 3) + '****' + val.substr(7)
  }
}

// 身份证打码
exports.idNum = (val) => {
  if (val) {
    return val.substr(0, 3) + '***********' + val.substr(15)
  }
}

// 姓名打码
exports.name = (val) => {
  if (val) {
    return val.substr(0, 1) + '*' + val.substr(2)
  }
}

// 价格格式化
exports.getNum = (val) => {
  if (val) {
    return val.slice(0, val.toString().indexOf('.') + 3)
  }
}



// WEBPACK FOOTER //
// ./src/filters/index.js